import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function CircleCheck({
  color,
  size,
  style,
  noFill,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z'
        stroke='currentColor'
      />
      <path
        d='M8.13843 11.67L11.0218 14.5533L15.8386 9.11549'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
